import React, { FC } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { Loader, Text } from '@whitesharx/starfall-frontend-ui-kit';

import { cardStyles, imageContainerStyles, textStyles } from '../styles.css';

const SearchCard: FC = () => (
  <div className={cardStyles}>
    <div className={imageContainerStyles}>
      <Loader />
    </div>
    <Text className={textStyles}>{t('game.selecting-opponent')}</Text>
  </div>
);

export default SearchCard;
